import { ContentNugget, PanelNuggetActionParams } from '@backrs_ui/common-ui';

import { getBookmarkIdForNugget } from '@backrs_ui/grow-ui/src/pages/Bookmarks/pages/bookmarks.util';
import {
  usePostBookmarkMutation,
  useDeleteBookmarkMutation,
  useGetBookmarksQuery,
} from '@backrs_ui/grow-ui/src/redux/bookmarks/bookmarks.api';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  openPlaylistListStep,
  setNuggetToAdd,
} from '@backrs_ui/grow-ui/src/redux/priorities/priorities.slice';
import { selectIsSharedSessionActive } from '@backrs_ui/grow-ui/src/redux/sharedSession/sharedSession';

import { handleBookmark } from './nugget.util';
import { getShareUrl } from './nuggetLinks';

export const useGetNuggetActionParams = (nugget: ContentNugget | null) => {
  const dispatch = useAppDispatch();
  const isSharedSession = useAppSelector(selectIsSharedSessionActive);
  const { data: bookmarks } = useGetBookmarksQuery(undefined);
  const bookmarkId = getBookmarkIdForNugget(bookmarks, nugget?.id, nugget?.variant);
  const [postBookmark] = usePostBookmarkMutation();
  const [deleteBookmark] = useDeleteBookmarkMutation();

  if (!nugget || isSharedSession) {
    return { actionParams: undefined };
  }

  const handleActionAddTask = () => {
    dispatch(openPlaylistListStep());
    dispatch(setNuggetToAdd(nugget));
  };

  const handleActionBookmark = async () => {
    await handleBookmark({
      bookmarkId,
      nuggetId: nugget.id,
      variant: nugget.variant,
      postBookmark,
      deleteBookmark,
    });
  };

  const handleActionShare = () => {
    const shareUrl = getShareUrl({ contentNugget: nugget });

    navigator.clipboard.writeText(shareUrl);
  };

  const actionParams: PanelNuggetActionParams = {
    onClick: handleActionAddTask,
    handleActionBookmark,
    handleActionAddTask,
    handleActionShare,
    hasBookmarked: !!bookmarkId,
  };

  return { actionParams };
};
